function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceModel1CircleAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 8,
      fill: "#28B869",
      stroke: "#ffffff"
    },
    cx: 60,
    cy: 60,
    r: 50
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceModel1CircleAvailable);
export default __webpack_public_path__ + "static/media/place_model-1_circle_available.da0e1dc95ed996f601ad2348961bbd83.svg";
export { ForwardRef as ReactComponent };